module.exports = __webpack_public_path__ + "static/media/Rec3.3b1da9cc.png";